<freud-loader
	class="loading zk-mt-15"
	*ngIf="loading"
	size="sm"
	[bgColor]="false"
></freud-loader>

<div class="empty" *ngIf="coeNotes.items.length === 0 && loading === false">
	<p>{{ 'CONTACT.INFOS.NO_NOTES' | translate }}</p>
</div>

<div class="coe-note" *ngFor="let item of coeNotes.items; index as index">
	<div class="v-line"></div>

	<div class="timeline-square">
		<span class="freud-icon freud-icon-md freud-icon-file-text"></span>
	</div>

	<div class="card">
		<div class="header">
			<div class="date">{{ item.createdAt | date: 'dd/MM/YYYY' }}</div>

			<div class="hour">
				<span class="freud-icon freud-icon-xs freud-icon-clock"></span>
				<div class="value">{{ item.createdAt | date: "H'h'mm" }}</div>
			</div>

			<div class="professional">
				<span class="freud-icon freud-icon-xs freud-icon-user-circle"></span>
				<p class="name">
					{{ item.professionalCoeName }} - {{ item.council }} {{ item.license }}
				</p>
			</div>
		</div>

		<div class="type">{{ item.type }}</div>

		<div class="note-content" [ngClass]="{ expanded: item.expanded === true }">
			<div class="annotation">
				{{ item.annotation }}
			</div>
			<div class="toggle-view" (click)="toggleCardView(item)">
				{{ item.expanded ? 'Ver menos' : 'Ver mais' }}
			</div>
		</div>
	</div>
</div>

<freud-button
	*ngIf="coeNotes.total && pageSize.actual < coeNotes.total && !loadingMore"
	(click)="loadMore()"
>
	{{ 'CONTACT.LOAD_MORE' | translate }}
</freud-button>

<freud-loader
	class="loading end-page"
	*ngIf="loadingMore"
	size="sm"
	[bgColor]="false"
></freud-loader>
